<template>
  <div>
    <ChartBox title="餐厅信息">
      <div data-title="门店信息 " class="box-left-one">
        <div class="logo">
          <div class="bg">
            <div class="phone" style="margin: 5px 0; font-size: 20px">
              <span>{{ shop_name }}</span>
            </div>
            <div class="phone">
              <span>负 责 人 ：</span>
              <span>{{ shop_owner }}</span>
            </div>
            <div class="phone">
              <span>联系电话：</span>
              <span>{{ shop_phone }}</span>
            </div>
          <div class="phone">
            <span>餐厅地址：</span>
            <span>{{ shop_address }}</span>
          </div>
          </div>
        </div>
      </div>
    </ChartBox>
  </div>
</template>

<script>
import ChartBox from "../components/chartBox.vue";
// 引入混入
import { myMixin } from "../common/common.js";

export default {
  data() {
    return {};
  },
  mixins: [myMixin],
  components: {
    ChartBox,
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.box-left-one {
    margin-top: 30px;
    .logo {
      position: relative;
      display: flex;
      align-items: center;
      height: 100%;
      height: calc(100% - 60px);
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 20px;
        opacity: 0.8;
      }
      .bg {
        color: white;
        padding-left: 20px;
        margin-top: 5px;
        z-index: 999;
        width: 100%;
        height: 100%;
        font-size: 16px;
        .phone{
          margin: 15px 0;
        }
      }
    }
  }
</style>
